<div>
    <form [formGroup]="dateForm" (ngSubmit)="onSubmitDate()" class="inp-row">
        <div class="inp-group">
            <label>Start Date</label>
            <input type="date" formControlName="startDate" [max]="maxDate">
        </div>

        <div class="inp-group">
            <label>End Date</label>
            <input type="date" formControlName="endDate" [max]="maxDate">
        </div>

        <div class="inp-group">
            <label></label>
            <button>Fetch report</button>
        </div>
    </form>
</div>

<div class="report-body">
    @if(isLoader){
    <table class="dp-table">
        <thead class="dp-table-header">
            <tr>
                <th>Received By</th>
                <th>Lot Received</th>
                <th>Email</th>
            </tr>
        </thead>
        <tbody class="dp-table-body">
            <tr *ngFor="let i of [].constructor(20)">
                <td *ngFor="let j of [].constructor(3)">
                    <dp-loader></dp-loader>
                </td>
            </tr>
        </tbody>
    </table>
    } @else {
    @if(reportData.length == 0 && !isLoader){
    <div class="noData">
        <div class="placeholderTable"></div>
        <p>No data found!</p>
    </div>
    } @else {
    <div class="dp-table-scroll">
        <table class="dp-table">
            <thead class="dp-table-header">
                <tr>
                    <th>Received By</th>
                    <th>Lot Received</th>
                    <th>Email</th>
                </tr>
            </thead>

            <tbody class="dp-table-body">
                @for (row of reportData; track row) {
                <tr [ngClass]="{ expanded: row.isExpanded }" (click)="onClickLotReport(row)">
                    <td>{{row.receivedUserName}}</td>
                    <td>{{ row.numberOfLotReceived }}</td>
                    <td>{{ row.receivedUserEmail }}</td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    }
    }
</div>